import type { SearchResult, SearchResultType } from '../../../../common/types';

export const SearchResultAssetsObjectSchema = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
}
`;

export interface SearchResultAssetsObjectSchema extends SearchResult {
	id: string;
	title: string;
	type: SearchResultType;
	description: string;
	lastModifiedDate: string;
	__typename: 'SearchResultAssetsObjectSchema';
}

export const isSearchResultAssetsObjectSchema = (
	partial: SearchResult,
): partial is SearchResultAssetsObjectSchema => {
	return partial.__typename === 'SearchResultAssetsObjectSchema';
};

export const getSearchResultAssetsObjectSchema = () => {
	return `
		${SearchResultAssetsObjectSchema}
	`;
};

export const SearchResultAssetsObjectType = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
	}
}
`;

export interface SearchResultAssetsObjectType extends SearchResult {
	id: string;
	title: string;
	type: SearchResultType;
	description: string;
	lastModifiedDate: string;
	objectSchemaEntity: {
		id: string;
		name: string;
	};
	__typename: 'SearchResultAssetsObjectType';
}

export const isSearchResultAssetsObjectType = (
	partial: SearchResult,
): partial is SearchResultAssetsObjectType => {
	return partial.__typename === 'SearchResultAssetsObjectType';
};

export const getSearchResultAssetsObjectType = () => {
	return `
		${SearchResultAssetsObjectType}
	`;
};

export const SearchResultAssetsObject = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
	}
	objectTypeEntity {
		id
		name
		icon {
			url48
		}
	}
}
`;

export interface SearchResultAssetsObject extends SearchResult {
	id: string;
	title: string;
	description: string;
	lastModifiedDate: string;
	type: SearchResultType;
	schemaAri: string;
	typeAri: string;
	objectSchemaEntity: {
		id: string;
		name: string;
	};
	objectTypeEntity: {
		id: string;
		name: string;
		icon: {
			url48: string;
		};
	};
	__typename: 'SearchResultAssetsObject';
}

export const isSearchResultAssetsObject = (
	partial: SearchResult,
): partial is SearchResultAssetsObject => {
	return partial.__typename === 'SearchResultAssetsObject';
};

export const getSearchResultAssetsObject = () => {
	return `
		${SearchResultAssetsObject}
	`;
};

export type SearchAssetsPartial =
	| SearchResultAssetsObjectSchema
	| SearchResultAssetsObjectType
	| SearchResultAssetsObject;

export const isSearchAssetsPartial = (partial: SearchResult): partial is SearchAssetsPartial => {
	return (
		isSearchResultAssetsObjectSchema(partial) ||
		isSearchResultAssetsObjectType(partial) ||
		isSearchResultAssetsObject(partial)
	);
};

export const getAssetsPartials = () => {
	return `
		${getSearchResultAssetsObjectSchema()}
		${getSearchResultAssetsObjectType()}
		${getSearchResultAssetsObject()}
	`;
};
